(function() {
    'use strict';

    angular.module('settings')
        .controller('SystemLogListController', SystemLogListController);

    SystemLogListController.$inject = ['systemLogDataSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'systemLogPermissionsConst', 'searchFilterSrvc', 'filterQuerySrvc'];

    function SystemLogListController(systemLogDataSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, systemLogPermissionsConst, searchFilterSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.systemLogRows = [];
        self.systemLogCols = [{
            title: 'Data',
            value: 'timestamp',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Typ',
            value: 'type',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Opis',
            value: 'description',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Stacktrace',
            value: 'stack',
            type: 'text',
        }];

        self.modelPermissions = systemLogPermissionsConst;
        self.searchQuery = {
            timestamp: null,
            type: null,
            description: null,
            ordering: null
        };

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getSystemLogs();
        }

        function getSystemLogs(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    timestamp: searchFilterSrvc.getDatetimeValue(self.searchQuery.timestamp),
                    type: self.searchQuery.type,
                    description: self.searchQuery.description,
                    ordering: self.searchQuery.ordering
                };
            }
            return systemLogDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.systemLogRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getSystemLogs);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getSystemLogs();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getSystemLogs();
        }
    }
})();
